 const locales = {
  en: require('./en'),
};

const messages = {
  SetVisibleRange: '设置可见范围',
  Confirm: '确定',
  Cancel: '取消',
  Import: '导入',
  Close: '关闭',
  AddPerson: '添加人员',
  Allemployees: '所有员工',
  Someemployees: '部分员工',
  SelectPerson: '选择人员',
  ImportPersonList: '导入名单',
  DownLoadPersonList: '下载名单',
  Tips: '提示',
  DownLoadProfile: '下载模板',
  ImportFile: '导入文件',
  PleaseSelectFile: '请选择文件',
  SelectFile: '选择文件',
  ContinueUploading: '继续上传',
  ClearSelected: '清空名单',
  DefaultSelectPersonSearchPlaceholder: '按姓名、部门、角色进行搜索',
  Selected: '已选',
  ToSelect: '可选',
  TabGroup: '组织架构',
  TabRole: '角色',
  UserGroup: '用户组',
  Administrator: '管理员',
  SelectTips1:
    '1、选择条目（人/部门）上限为500条，选择部门默认包含部门下所有员工/子部门。',
  SelectTips2: '2、点击确定后，平台会去重员工账号，确保员工不被重复添加。',
  SelectTipsOK: '点击“确定”后，平台将以当前设置数据范围方式为准，覆盖原有数据',
  ImportTips: '导入名单限制500条, ',
  DownloadTemplate: '下载名单',
  ErrorTipsNoMeet: '存在不符合模板要求的文件，请检查！',
  ErrorTipsEmpty: '存在内容为空的文件，请检查！',
  ErrorTipsIncorrect: '文件类型不正确！',
  ErrorTipsNoEmployee: '请选择人员后再保存！',
  ErrorTipsLimmit: '选择数据请不要超过500条！',
  ErrorTipsNoChange: '数据无变化！',
  SaveSuccess: '保存成功',
  SlectLimmit: '选择数据上线500条，当前部门人数过多。',
  Imported: '导入',
  Succeeded: '成功',
  Duplicate: '重复',
  Failed: '失败',
  YouCan: '可',
  DownLoadDetailList: '下载详情清单',
  ModifyUpload: '修改后重新上传',
  TipsReWrite: '如果导入文件内有重复内容，系统将自动去重',
  TipsImport: '点击“导入”后，以当前最新的名单覆盖之前的历史设置',
  GetAllUserGroupInfoRejectTips: '数据存在问题，用户组总数不可超过500',
  FileNotMeetRequire: '存在不符合模板要求的文件，请检查!',
  EmptyFileExists: '存在为空的文件，请检查!',
  FileTypeError: '文件类型不正确!',
  ToManyToSelectAll: '当前部门人数过多，请直接在上层组织中勾选该部门!',
  Invalidate: '失效',
  OnlyDataRange: '仅支持应用管理员和开发者角色设置数据范围',
  SetDataRange: '设置数据范围',
};
export default {locales, ...messages};